export default "__VITE_ASSET__e16398be__"